import React, { useCallback, useContext, useState } from "react";
import { MessageFormatElement } from "react-intl";
import localStorage from "../../../core/common/localStorage";
import i18nMessages from "../../../i18n";

export enum Locale {
    ItIt = "it-IT",
    EnUs = "en-US",
}

interface LanguageProviderState {
    locale: string;
    messages: Record<string, MessageFormatElement[]>;
}

const LanguageContext = React.createContext<any>({
    locale: Locale.ItIt,
    messages: i18nMessages.it,
});

interface LanguageProviderProps {
    children: any;
    locale: string;
    messages: Record<string, MessageFormatElement[]>;
}

const LanguageProvider = ({
    children,
    locale,
    messages,
}: LanguageProviderProps) => {
    const [languageProviderState, setLanguageProviderState] =
        useState<LanguageProviderState>({
            locale: locale,
            messages: messages,
        });

    const setLanguage = useCallback((locale: Locale) => {
        const messages =
            locale === Locale.ItIt ? i18nMessages.it : i18nMessages.en;
        setLanguageProviderState({
            locale: locale,
            messages: messages,
        });
        localStorage.set("language", locale);
    }, []);

    return (
        <LanguageContext.Provider
            value={{ setLanguage, ...languageProviderState }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};

export default LanguageProvider;
